export function groupBy<T, K>(list: T[], getKey: (item: T) => K): Map<K, T[]> {
  const map = new Map<K, T[]>();
  list.forEach(item => {
    const key = getKey(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

const isIOSWebview = (navigator: Navigator) => {
  if (navigator) {
    const ua = navigator.userAgent.toLowerCase();
    const ios = /iphone|ipod|ipad/.test(ua);
    const iosBrowser = /safari/.test(ua);
    const xingApp = /xing/.test(ua);

    return ios && !iosBrowser && xingApp;
  }

  return false;
};

const isAndroidWebview = (navigator: Navigator) => {
  if (navigator) {
    const ua = navigator.userAgent.toLowerCase();
    const android = /android/.test(ua);
    const androidWebView = /version\/\d\.\d/.test(ua);
    const xingApp = /xing/.test(ua);

    return android && androidWebView && xingApp;
  }

  return false;
};

export const isWebview = (navigator: Navigator) => {
  return isIOSWebview(navigator) || isAndroidWebview(navigator);
};
